import * as React from "react";
import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import avatar from "../../Assets/svg/avatar-img.svg";
import { useSelector } from "react-redux";
import { useEffect } from "react";

export default function Avatars(props) {
  const alumni = useSelector((state) => state.connect.alumnis);
  const scholars = useSelector((state) => state.connect.scholars);
  const [imageList, setImageList] = React.useState([]);
  const makeAvatars = () => {
    let list = props?.type === "alumni" ? [...alumni] : [...scholars];
    let newList = [];
    for (let i = 0; i < list?.length; i++) {
      if (newList?.length < 4 && list[i]?.image && list[i]?.imageExtension) {
        newList = [
          ...newList,
          `data:image/${list[i]?.imageExtension};base64,${list[i]?.image}`,
        ];
      }
    }
    setImageList([...newList]);
  };
  useEffect(() => {
    makeAvatars();
  }, []);
  return (
    <AvatarGroup
      renderSurplus={(surplus) => <span>+{surplus.toString()[0]}k</span>}
      // total={4251}
    >
      {imageList?.map((item, index) => (
        <Avatar key={index} alt="Remy Sharp" src={item} />
      ))}
      {/* <Avatar alt="Travis Howard" src={avatar} />
      <Avatar alt="Agnes Walker" src={avatar} />
      <Avatar alt="Trevor Henderson" src={avatar} /> */}
    </AvatarGroup>
  );
}
